module.exports = __webpack_public_path__ + "static/media/ETH2x.d3d15b80.png";